import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { teamContactMailtoHref } from '../../utils/teamContact';
import { OfflineAlert, OfflineContactLink } from './StorefrontOfflineAlert.styled';

const GO_LIVE_MAIL_SUBJECT = 'NKY Connect: ready to go live';

export default function StorefrontOfflineAlert() {
  return (
    <OfflineAlert icon={<InfoOutlinedIcon />} severity="info">
      Your storefront is currently <strong>offline</strong>. Once your setup is
      complete, our team will activate it for you. If you're ready to go live,
      please{' '}
      <OfflineContactLink
        href={teamContactMailtoHref({ subject: GO_LIVE_MAIL_SUBJECT })}
        underline="always"
      >
        contact us
      </OfflineContactLink>
      .
    </OfflineAlert>
  );
}
